import SpriteSymbol from "../../../../../../../ldcustomer/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../ldcustomer/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart",
  "use": "icon-heart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-heart\"><path d=\"M32 407.584a279.584 279.584 0 0 1 480-194.944 279.584 279.584 0 0 1 480 194.944 278.144 278.144 0 0 1-113.024 224.512L562.592 892.8a96 96 0 0 1-124.416-1.952l-308.16-270.688A278.976 278.976 0 0 1 32 407.584z\" p-id=\"6340\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol